import { render, staticRenderFns } from "./Ahistorytable.vue?vue&type=template&id=72430c84"
import script from "./Ahistorytable.vue?vue&type=script&lang=js"
export * from "./Ahistorytable.vue?vue&type=script&lang=js"
import style0 from "./Ahistorytable.vue?vue&type=style&index=0&id=72430c84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports